<style scoped>
.box{
    padding: .3rem;
}
.title {
  font-size: 0.3rem;
  line-height: 0.42rem;
  color: #333;
  margin-bottom: .24rem;
}
.time{
    color: #999;
    font-size: .24rem;
    margin-bottom: .3rem;
}

.content{
    font-size: .28rem;
    line-height: .38rem;
}
</style>
<template>
  <div style="padding-top: 1rem; padding-bottom: 1rem">
    <topbar text="开心一刻" :status="true"></topbar>
    <div class="box">
      <div class="title">{{ detail.smileTitle }}</div>
      <div class="time">{{detail.createTime | time}}</div>
      <div class="content" v-html="detail.content"></div>
    </div>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";

import noMoreData from "components/no-more-data";
import topbar from "components/topbar";
import moment from "moment/moment";

import { Swiper, Slide } from "vue-swiper-component";
import { serialize } from "utils/index";

export default {
  data() {
    return {
      handMove: false,
      mask: false,
      content: "",
      likeStatus: false,
      microId: "",
      microCommentList: [],
      detail: {},
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      userId: "",
      pageIndex: 1,
      pageSize: 4,
      noMoreData: false,
      isLoading: false,
      count: 0,
    };
  },
  components: {
    noMoreData,
    topbar,
    Swiper,
    Slide,
  },
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
  },
  computed: {},
  methods: {
    cancle() {
      this.mask = false;
    },
    openMask() {
      this.mask = true;
    },
    back() {
      history.back();
    },
    init() {
      this.content = "";
      this.mask = false;
    },
    async commitMicroComment() {
      if (!this.content) {
        alert("请您输入评论内容~");
      } else {
        let data = await getSources(
          "/bear-scale/api/micro/commitMicroComment.json",
          {
            microId: this.microId,
            userId: this.userId,
            content: this.content,
          }
        );
        if (data.status === 0) {
          this.getMicroCommentList();
          this.init();
        } else {
          alert(data.msg);
        }
      }
    },
    to(n) {
      this.$router.push(`/${n}`);
    },
    async getMicroCommentList() {
      let data = await getSources(
        "/bear-scale/api/micro/getMicroCommentList.json",
        {
          pageIndex: 1,
          pageSize: 20,
          microId: this.microId,
        }
      );
      if (data.status === 0) {
        this.microCommentList = data.microCommentList;
        this.count = data.count;
      } else {
        alert(data.msg);
      }
    },
    async doLoveMicro() {
      let data = await getSources("/bear-scale/api/micro/doLoveMicro.json", {
        microId: this.microId,
      });
      if (data.status === 0) {
        this.likeStatus = true;
        this.getMicroDetail();
      }
    },
    async getMicroDetail() {
      let obj = {};
      obj.smileId = this.$route.query.id;
      let data = await getSources(
        "/bear-scale/api/microSmile/getSmileDetail",
        obj
      );
      if (data.status === 0) {
        this.detail = data.smileInfo;
      } else {
        alert(data.msg);
      }
    },
  },
  mounted() {
    this.userId = localStorage.getItem("userId");
    this.getMicroDetail();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/jokeDetail.vue?5a6cedb8